import app from 'flarum/forum/app';

/**
 * Sponsor slots and the newsletter signup box, provided by voucha/ads and
 * voucha/newsletter. Each helper renders nothing if that extension isn't
 * enabled, so the calculators never depend on them.
 */

// Salary Converter: the non-Naira side decides the country
export const CURRENCY_COUNTRY = {
  USD: 'US',
  GBP: 'GB',
  CAD: 'CA',
  NGN: 'NG'
};
// Business Tax: "country of residence" values
export const RESIDENCE_COUNTRY = {
  nigeria: 'NG',
  canada: 'CA',
  us: 'US',
  uk: 'GB'
};

/** "US tax results powered by [sponsor]" (country branding bookings) */
export function brandLine(tool, country, label) {
  const ads = app.vouchaAds;
  if (!ads || !country) return null;
  // No `key`: these sit among unkeyed siblings, and Mithril throws on mixed keys. The slot re-fetches itself when the country changes.
  return m(ads.Slot, {
    placement: 'country_branding',
    tool,
    country,
    label
  });
}

/** Sponsored card right after a result (calculator sponsorship bookings) */
export function sponsorCard(tool, country) {
  const ads = app.vouchaAds;
  if (!ads) return null;
  return m(ads.Slot, {
    placement: 'calculator',
    tool,
    country: country || ''
  });
}

/** Newsletter signup box: the calculators offer the Weekly Finance Update only */
export function signupBox(source) {
  const newsletter = app.vouchaNewsletter;
  if (!newsletter) return null;
  return m(newsletter.SignupBox, {
    source,
    categories: ['weekly-finance'],
    fixed: true
  });
}